/* eslint-disable */
// @ts-nocheck

import React from 'react'

import {
  CurrencyDollarIcon,
  DocumentTextIcon,
  HashtagIcon,
  UserIcon,
} from '@heroicons/react/24/outline'

import { DateFilter } from '@/containers/billing/register/billingFilters/filter/DateFilter'

import { useFilterOptions } from '../hooks/useFilterOptions'
import {
  orderStatusOptions,
  paymentStatusOptions,
} from './constants/statusOptions'
import { RangeFilter } from './filter/RangeFilter'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { usePurchaseOrderFilters } from './hooks/usePurchaseOrderFilters'
import { SelectionSummary } from './SelectionSummary'

export const FiltersRow: React.FC = () => {
  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    updateIssueDateFrom,
    updateIssueDateTo,
    updateAmountFrom,
    updateAmountTo,
    updateProductTotalFrom,
    updateProductTotalTo,
    updateOrderStatus,
    updatePaymentStatus,
    updateClientId,
    clearAllFilters,
    hasActiveFilters,
  } = usePurchaseOrderFilters()

  // Get filter options from API
  const { clientOptions } = useFilterOptions()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <div className="min-w-[220px] flex-1">
            <SearchQuery
              onSearchChange={updateSearch}
              placeholder="Buscar por No. orden de compra..."
              searchQuery={filters.search}
            />
          </div>
          <SelectFilter
            activeSelections={filters.clientId}
            icon={<UserIcon className="h-4 w-4" />}
            onSelectionsChange={updateClientId}
            placeholder="Buscar cliente..."
            searchActive={true}
            selectionOptions={clientOptions}
            title="Cliente"
          />
          <SelectFilter
            activeSelections={filters.orderStatus}
            icon={<DocumentTextIcon className="h-4 w-4" />}
            onSelectionsChange={updateOrderStatus}
            placeholder="Buscar estado..."
            searchActive={false}
            selectionOptions={orderStatusOptions}
            title="Estado de la orden"
          />
          <SelectFilter
            activeSelections={filters.paymentStatus}
            icon={<CurrencyDollarIcon className="h-4 w-4" />}
            onSelectionsChange={updatePaymentStatus}
            placeholder="Buscar estado..."
            searchActive={false}
            selectionOptions={paymentStatusOptions}
            title="Estado del pago"
          />
          <RangeFilter
            currency={true}
            icon={<CurrencyDollarIcon className="h-4 w-4" />}
            onValueFromChange={updateAmountFrom}
            onValueToChange={updateAmountTo}
            placeholder="Seleccionar importe..."
            title="Importe"
            valueFrom={filters.amountFrom}
            valueTo={filters.amountTo}
          />
          <RangeFilter
            currency={false}
            icon={<HashtagIcon className="h-4 w-4" />}
            onValueFromChange={updateProductTotalFrom}
            onValueToChange={updateProductTotalTo}
            placeholder="Seleccionar cantidad..."
            title="Total de productos"
            valueFrom={filters.productTotalFrom}
            valueTo={filters.productTotalTo}
          />
          <DateFilter
            dateFrom={filters.issueDateFrom}
            dateTo={filters.issueDateTo}
            hideDateTypeSelect
            onDateRangeChange={(from, to) => {
              updateIssueDateFrom(from || '')
              updateIssueDateTo(to || '')
            }}
            onDateTypeChange={() => {}}
            selectedDateType={''}
          />
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            amountFrom={filters.amountFrom}
            amountTo={filters.amountTo}
            clientId={filters.clientId}
            clientOptions={clientOptions}
            handleClearFilters={handleClearFilters}
            issueDateFrom={filters.issueDateFrom}
            issueDateTo={filters.issueDateTo}
            orderStatus={filters.orderStatus}
            orderStatusOptions={orderStatusOptions}
            paymentStatus={filters.paymentStatus}
            paymentStatusOptions={paymentStatusOptions}
            searchQuery={filters.search}
            setAmountFrom={updateAmountFrom}
            setAmountTo={updateAmountTo}
            setClientId={updateClientId}
            setIssueDateFrom={updateIssueDateFrom}
            setIssueDateTo={updateIssueDateTo}
            setOrderStatus={updateOrderStatus}
            setPaymentStatus={updatePaymentStatus}
            setSearchQuery={updateSearch}
          />
        )}
      </div>
    </div>
  )
}
